<bdr-hero-image></bdr-hero-image>
<bdr-dialog-list></bdr-dialog-list>